import React, { useState, useEffect } from "react";
import { notification } from "antd";
import _ from "lodash";
import $axios from "../../services/axios";
import { useLocation, useHistory } from "react-router-dom";

const PaymentResult = ({ setLoading, loading }) => {
  const history = useHistory();
  const location = useLocation();
  const [statusPayment, setStatusPayment] = useState(false);
  const [transaction, setTransaction] = useState(null);
  const [errorPaymentHandle, setErrorPaymentHandle] = useState(false);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    // handlePayment();
  }, []);

  const handlePayment = async () => {
    setLoading(true);
    const queryParams = new URLSearchParams(location.search);
    const amount = queryParams.get("amount");
    const payment_type = queryParams.get("payment_type");
    const reference_number = queryParams.get("reference_number");
    const status = queryParams.get("status");
    const trans_ref_no = queryParams.get("trans_ref_no");
    const website_id = queryParams.get("website_id");
    const signature = queryParams.get("signature");
    const messageVtc = queryParams.get("message");
    setStatusPayment(status === "1");
    try {
      const body = {
        OrderId: reference_number,
        Amount: Number(amount),
        Message: messageVtc,
        Status: Number(status),
        PaymentType: payment_type,
        ReferenceNumber: reference_number,
        TransRefNo: trans_ref_no,
        WebsiteId: website_id,
        Signature: signature,
      };
      await $axios.$post(
          "/payment/paymentHandle",
        body
      );
    } catch (error) {
      setErrorPaymentHandle(true);
      notification.error({
        status: "error",
        message: "Thất bại",
        description: "Đã có lỗi xảy ra!",
      });
    } finally {
      if (status === "1") {
        const res = await $axios.$get(
          `/transactions/details?orderCode=${reference_number}`
        );
        setTransaction(res.data.data.data);
      }
      setLoading(false);
      setLoaded(true);
      setTimeout(() => {
        const { pathname } = location;
        history.replace(pathname);
      }, 2000);
    }
  };

  return (
    <div className="w-full mb-4 top-[100px] relative">
      <div className="flex flex-col justify-center gap-4 w-full px-4 items-center">
        {loaded && (
          <>
            {statusPayment ? (
              <div>
                <div className="text-[20px] text-[#00AB56] font-bold text-center mb-4">
                  Thanh toán thành công 
                </div>
                {!errorPaymentHandle && transaction && (
                  <div className="text-center text-[16px] text-[#27272A]">
                    Cảm ơn bạn đã sử dụng dịch vụ
                  </div>
                )}
              </div>
            ) : (
              <div className="text-[20px] text-[#D72F20] font-bold text-center">
                Thanh toán thất bại
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default PaymentResult;
